import React, { useContext } from 'react';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ProductOverviewDesktop } from '../ProductOverviewDesktop';
import { ProductOverviewMobile } from '../ProductOverviewMobile';
import {
  defaultThemeProperties,
  productOverviewDefaultProps,
  productOverviewPropTypes,
  themeProperties
} from '../helpers';
import { PLA_FEATURE_SWITCH } from '../constants';

export const SingleProductOverviewComponent = (
  {
    itemId,
    showRichContentsOnly = false,
    hideRichContents = false,
    preview = false,
    quickLinks = false,
    showReturnMessage = false,
    forceMobile = false,
    headingTitle = 'Product Overview',
    richContentsOnlyRef = null,
    showPla = false,
    isUsingAccordion = false
  }
) => {
  const { channel } = useContext(ExperienceContext);
  const showSponsoredPla = useConfigService(PLA_FEATURE_SWITCH) || false;

  return (
    <div
      data-section="product-overview"
      data-component="ProductOverviewAccordionBody"
      className="sui-w-full"
    >
      {!forceMobile && channel === 'desktop' ? (
        <ProductOverviewDesktop
          itemId={itemId}
          isUsingAccordion
          showRichContentsOnly={showRichContentsOnly}
          quickLinks={quickLinks}
          hideRichContents={hideRichContents}
          preview={preview}
          showReturnMessage={showReturnMessage}
          showPla={showSponsoredPla}
        />
      )
        : (
          <ProductOverviewMobile
            itemId={itemId}
            showRichContentsOnly={showRichContentsOnly}
            quickLinks={quickLinks}
            hideRichContents={hideRichContents}
            preview={preview}
            showReturnMessage={showReturnMessage}
            showPla={showSponsoredPla}
          />
        )}
    </div>
  );
};

SingleProductOverviewComponent.displayName = 'SingleProductOverviewComponent';

SingleProductOverviewComponent.themeProps = themeProperties;

SingleProductOverviewComponent.defaultThemeProps = defaultThemeProperties;

SingleProductOverviewComponent.propTypes = productOverviewPropTypes;

const SingleProductOverview = withErrorBoundary(SingleProductOverviewComponent);

SingleProductOverview.displayName = 'SingleProductOverview';

SingleProductOverview.propTypes = productOverviewPropTypes;

SingleProductOverview.defaultProps = productOverviewDefaultProps;

SingleProductOverview.themeProps = themeProperties;

SingleProductOverview.defaultThemeProps = defaultThemeProperties;

export default SingleProductOverview;
